import { cva } from '@/styled-system/css';

export const bannerRecipe = cva({
  base: {
    'display': 'flex',
    'justifyContent': 'center',
    'paddingBlock': 'Banner.padding.vert',
    'paddingInline': 'Banner.padding.horz',
    'textStyle': 'body',
    'borderRadius': 'Banner',
    'gap': 'Banner.gap.trailing',
    '&:has([data-c11n-component="Banner.Close"]) > [data-c11n-component="Banner.Body"]': {
      flex: 'auto',
    },
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Banner.critical.bg',
        color: 'Banner.critical.text',
      },
      info: {
        backgroundColor: 'Banner.info.bg',
        color: 'Banner.info.text',
      },
      success: {
        backgroundColor: 'Banner.success.bg',
        color: 'Banner.success.text',
      },
      warning: {
        backgroundColor: 'Banner.warning.bg',
        color: 'Banner.warning.text',
      },
    },
  },
});
